export default __webpack_public_path__ + "static/media/Image12.ab262d0a.png";